import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Self, input, model } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';

import { FormControlPipe } from '@shared/pipe';
import { ICheckboxCustomClass } from '@data/schema';

@Component({
    selector: 'app-checkbox-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormControlPipe],
    templateUrl: './checkbox-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxInputComponent implements ControlValueAccessor {
    label = input.required<string>();
    checked = model<boolean>(false);
    testAutomationSelectorName = input<string>();
    customClasses = input<ICheckboxCustomClass>({
        formGroup: 'mb-3',
        label: 'form-label fw-medium d-flex align-items-center gap-2',
        input: 'form-check-input',
        labelPadding: '',
    });

    readonly type = 'checkbox';

    constructor(@Self() public ngControl: NgControl) {
        this.ngControl.valueAccessor = this;
    }

    writeValue(obj: any): void {
        this.setChecked(!!obj);
    }

    registerOnChange(_fn: any): void {}
    registerOnTouched(_fn: any): void {}

    handleCheckboxChange(event: Event) {
        this.setChecked((<HTMLInputElement>event.target).checked);
        this.ngControl?.control?.setValue(this.checked());
    }

    private setChecked(checked: boolean) {
        if (checked !== this.checked()) {
            this.checked.set(checked);
        }
    }
}
